import Msg from './app.vue'
export default Msg;



// WEBPACK FOOTER //
// ./src/index.js